import React from "react";
import Title from "../../layout/Title";
import {
  useLanguage,
  useExtra,
  useExtraUpdate,
  useActive,
} from "../../context/LanguageContext";

const FacebookAdsExtras = () => {
  const activeLanguage = useLanguage();
  const extras = useExtra();
  const handleExtras = useExtraUpdate();
  const isActive = useActive();

  function handleClick(type) {
    handleExtras(type);
  }

  return (
    <div className="faceads__extras">
      <Title />
      <div className="faceads__extras__button-set__container">
        <div className="faceads__extras__button-set">
          <h3
            className="faceads__extras__button"
            onClick={() => handleClick("Instructions")}
            style={
              isActive === "Instructions" ? { backgroundColor: "#d6d6d6" } : {}
            }>
            <i className="fas fa-question-circle faceads__extras__icon" />
          </h3>
          <h3
            className="faceads__extras__button"
            onClick={() => handleClick("Disclaimer")}
            style={
              isActive === "Disclaimer" ? { backgroundColor: "#d6d6d6" } : {}
            }>
            <i className="fas fa-exclamation-triangle faceads__extras__icon" />
          </h3>
        </div>
      </div>
      <div
        className="faceads__extras__message"
        style={
          isActive !== "none" ? { display: "block" } : { display: "none" }
        }>
        <div className="faceads__extras__message__title">
          {isActive === "Instructions" ? activeLanguage.instructions : ""}
          {isActive === "Disclaimer" ? "Disclaimer" : ""}
        </div>

        <p
          style={
            isActive === "Disclaimer"
              ? { fontWeight: "bold" }
              : { fontWeight: "normal" }
          }>
          {extras.text.p0}
        </p>
        <p className="faceads__extras__message__paragraph">{extras.text.p1}</p>
        <p className="faceads__extras__message__paragraph">{extras.text.p2}</p>
        <p className="faceads__extras__message__paragraph">{extras.text.p3}</p>
        <p className="faceads__extras__message__paragraph">{extras.text.p4}</p>
        <p>{extras.text.p5}</p>
        <p>{extras.text.p6}</p>
        <p>{extras.text.p7}</p>
        <p>{extras.text.p8}</p>
        <p>{extras.text.p9}</p>
      </div>
    </div>
  );
};

export default FacebookAdsExtras;
